var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRepeatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Repeat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Badge/Icon",
    transform: "translate(-8.000000, -10.000000)",
    stroke: "#3399FF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Repeat",
    transform: "translate(9.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0434783,3.42222222 C17.2565217,4.2 18,5.56111111 18,7 C18,9.37222222 16.0826087,11.2777778 13.6956522,11.2777778 L4.30434783,11.2777778",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.95652174,10.5777778 C0.743478261,9.8 0,8.43888889 0,7 C0,4.62777778 1.9173913,2.72222222 4.30434783,2.72222222 L13.6956522,2.72222222",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "10.9565217 5.44444444 13.6956522 2.72222222 10.9565217 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "7.04347826 14 4.30434783 11.2777778 7.04347826 8.55555556"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatIcon);
export default __webpack_public_path__ + "static/media/repeat-icon.b170cf27.svg";
export { ForwardRef as ReactComponent };